export default "__VITE_ASSET__7f5b616c__"